module.exports = __webpack_public_path__ + "img/gobe.16835ead.png";